import { useState, useEffect } from "react";
import axios from "axios";
import { Phone } from "lucide-react";
import useAuth from "../../hooks/useAuth";
import Swal from "sweetalert2";

function SIPLoginModal({ setIsOpen, setFormConfig, updateConfig, formConfig, connect, setIsEnabled, setSipDetails, sipDetails }) {
    const [username, setUsername] = useState(sipDetails?.username || sipDetails?.sip_id || "");
    const [password, setPassword] = useState(sipDetails?.password || "");
    const [submitting, setSubmitting] = useState(false);

    const { auth } = useAuth();

    // Close on ESC
    useEffect(() => {
        const handleEsc = (e) => {
            if (e.key === "Escape") setIsOpen(false);
        };
        window.addEventListener("keydown", handleEsc);
        return () => window.removeEventListener("keydown", handleEsc);
    }, [setIsOpen]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSubmitting(true);

        const config = { headers: { "Content-Type": "application/json" } };
        const post_data = {
            user_id: auth?.user_details?.user,
            sipuser: username,
            password: password,
            user_type: auth?.user_details?.type,
        };

        try {
            const res = await axios.post(
                process.env.REACT_APP_API_URL + "/contactcentre/create_sip_config/",
                post_data,
                config
            );
            if (res.data?.status === "error") {
                Swal.fire({
                    title: "Sip Registration Failed",
                    text: res.data?.error,
                    confirmButtonColor: "#2F6FED",
                    icon: "warning",
                });
                setIsEnabled(false);
                return;
            }
            const response = res.data?.data;
            const sip_data = {
                username: response.sip_id || "",
                password: response.password || "",
                domain: response.domain || "",
                webrtcUrl: response.proxy_url || "",
            };
            setSipDetails(sip_data);
            setFormConfig(sip_data);
            updateConfig(sip_data);
            connect(sip_data);
            setIsOpen(false);
            setIsEnabled(true);
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div className="dash2 sip-login-popup">
            <div className="sip-login-head">
                <div className="sip-login-icon">
                    <Phone size={18} />
                </div>
                <div className="sip-login-head-text">
                    <h3>SIP Registration</h3>
                    <div className="sip-login-sub">Connect your extension to take calls</div>
                </div>
                <button
                    type="button"
                    className="campaign-picker-close"
                    onClick={() => setIsOpen(false)}
                    title="Close"
                >
                    ×
                </button>
            </div>

            <form onSubmit={handleSubmit} autoComplete="off" className="sip-login-body">
                <div className="sip-login-field">
                    <label>Username</label>
                    <input
                        type="text"
                        autoComplete="off"
                        name="sip_username"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                        required
                    />
                </div>

                <div className="sip-login-field">
                    <label>Password</label>
                    <input
                        type="password"
                        autoComplete="new-password"
                        name="sip_password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                    />
                </div>

                <button type="submit" className="sip-login-submit" disabled={submitting}>
                    {submitting ? "Registering…" : "Register"}
                </button>
            </form>
        </div>
    );
}

export default SIPLoginModal;
